import axios from 'axios';

// Timelapses de cada período ya armados por TIMELAPSE-SEMANAL (los sábados): GET /api/timelapse-semanal/:feedId en el
// backend de LisualPro -> { generado, periodos: { todos|90|60|30|15: { url, desde, hasta, segundos } } }.
const BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';

export const semanalApi = axios.create({ baseURL: `${BASE.replace(/\/$/, '')}/api/timelapse-semanal`, timeout: 20000 });
semanalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const cache = new Map(); // feedId -> Promise (una consulta por cámara mientras dura la página)

/** Nunca falla: si el backend no lo tiene o no responde, devuelve { periodos: {} } y el front arma el video en el momento. */
export const leerTimelapseSemanal = (feedId) => {
  if (!cache.has(feedId)) {
    cache.set(feedId, semanalApi.get(`/${encodeURIComponent(feedId)}`).then((r) => r.data || { periodos: {} }).catch(() => ({ periodos: {} })));
  }
  return cache.get(feedId);
};
